var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FF7000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8035 28.8843C42.8035 29.9692 42.2159 30.9184 41.3119 31.4156V38.2861C41.3119 38.7381 40.9955 39.7326 39.8654 39.7326C39.549 39.7326 39.2326 39.6422 39.0066 39.4162L35.1194 36.3425C33.2209 34.8057 30.7801 33.9468 28.3392 33.9468H27.0284C26.938 34.4441 26.8476 34.8961 26.8476 35.3933C26.8476 36.7493 27.2996 37.9245 28.0228 38.9189C28.746 39.8682 28.0228 41.179 26.8476 41.179H23.5027C22.9603 41.179 22.4631 40.9078 22.2371 40.4106C21.4687 38.9189 21.0619 37.2013 21.0619 35.3933C21.0619 34.9413 21.1071 34.4441 21.1523 33.9468H19.6606C18.0334 33.9468 16.7678 32.6812 16.7678 31.054V26.7147C16.7678 25.1327 18.0334 23.8218 19.6606 23.8218H28.3392C30.7801 23.8218 33.2209 23.0082 35.1194 21.4714L39.0066 18.3977C39.2326 18.1717 39.549 18.0361 39.9106 18.0361C41.0407 18.0361 41.3571 19.121 41.3571 19.5278V26.3983C42.2159 26.8955 42.8035 27.8447 42.8035 28.8843ZM38.4642 35.3029V22.511L36.9274 23.7314C34.4865 25.6751 31.4581 26.7147 28.3392 26.7147V31.054C31.4581 31.054 34.4865 32.1388 36.9274 34.0824L38.4642 35.3029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.bbef3f3dee2900c2ff854b191d36bac0.svg";
export { ForwardRef as ReactComponent };